import { Star } from "lucide-react";
import { SidebarMenuButton } from "@/components/blocks/evo-sidebar";
import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuTrigger,
} from "@/components/ui/context-menu";
import type { MenuItem } from "../types";

interface MenuItemWithContextProps {
  item: MenuItem;
  uniqueId: string;
  isActive: boolean;
  isFavoriteItem?: boolean;
  isFavorite: boolean;
  onItemClick: (page: string, itemId: string) => void;
  onToggleFavorite: (itemId: string) => void;
  favoritesEnabled: boolean;
}

/**
 * Menu Item with Context Menu
 * Renders a menu item with right-click context menu for favoriting
 */
export function MenuItemWithContext({
  item,
  uniqueId,
  isActive,
  isFavoriteItem = false,
  isFavorite,
  onItemClick,
  onToggleFavorite,
  favoritesEnabled,
}: MenuItemWithContextProps) {
  const Icon = item.icon;

  const menuButton = (
    <SidebarMenuButton
      tooltip={item.label}
      onClick={() => onItemClick(item.page, uniqueId)}
      isActive={false}
      className={
        isFavoriteItem && isActive
          ? "bg-warning-100 text-warning-900 [&_svg]:text-warning-600 hover:bg-warning-100 hover:text-warning-900"
          : isFavoriteItem
          ? "text-warning-700 hover:bg-warning-50 hover:text-warning-900 active:bg-warning-100 active:text-warning-900 [&_svg]:text-warning-600 [&_svg]:hover:text-warning-600 [&_svg]:active:text-warning-600"
          : isActive
          ? "bg-sidebar-accent text-sidebar-accent-foreground"
          : ""
      }
    >
      <Icon />
      <span>{item.label}</span>
    </SidebarMenuButton>
  );

  if (!favoritesEnabled) {
    return menuButton;
  }

  return (
    <ContextMenu>
      <ContextMenuTrigger asChild>{menuButton}</ContextMenuTrigger>
      <ContextMenuContent>
        <ContextMenuItem onClick={() => onToggleFavorite(item.id)}>
          <Star className={isFavorite ? "fill-current" : ""} />
          {isFavorite ? "Remove from favorites" : "Set as favorite"}
        </ContextMenuItem>
      </ContextMenuContent>
    </ContextMenu>
  );
}
